import React from 'react';

export default function ValidationError({ message }) {
  if (!message) return null;

  return (
    <span
      className='absolute left-0 -bottom-5 text-xs text-red-500 font-medium tracking-wide'
      style={{ pointerEvents: 'none' }}
    >
      {message}
    </span>
  );
}
